import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    };
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
                <Header />
                <div className="mt-4 mb-4 "style={{minHeight:"550px"}}>

                </div>
                <Footer/>
            </div>
        )
    }
}
export { About };